export default {"name":"Dark","dark":true};